import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../integrations/supabase/client';
import { Button } from './ui/button';
import { X, Briefcase } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ProviderOnboardingBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const checkProviderStatus = async () => {
      if (!user) return;

      try {
        const { data: profile } = await supabase
          .from('profiles')
          .select('provider_intent, provider_registration_completed')
          .eq('user_id', user.id)
          .single();

        if (profile?.provider_intent && !profile?.provider_registration_completed) {
          const dismissed = sessionStorage.getItem('provider-banner-dismissed');
          if (!dismissed) {
            setShowBanner(true);
          }
        }
      } catch (error) {
        console.error('Error checking provider status:', error);
      }
    };

    checkProviderStatus();
  }, [user]);

  const handleDismiss = () => {
    sessionStorage.setItem('provider-banner-dismissed', 'true');
    setIsDismissed(true);
    setShowBanner(false);
  };

  const handleComplete = () => {
    navigate('/register-provider', { state: { isOnboarding: true } });
  };

  if (!showBanner || isDismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <Briefcase className="h-5 w-5 flex-shrink-0" />
            <div className="flex-1">
              <p className="font-medium text-sm">{t('services.completeProfileBanner')}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              onClick={handleComplete}
              size="sm"
              variant="secondary"
              className="bg-white text-purple-700 hover:bg-gray-100"
            >
              {t('services.completeNow')}
            </Button>
            <Button
              onClick={handleDismiss}
              size="sm"
              variant="ghost"
              className="text-white hover:bg-white/20"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
